import styled from "styled-components";

export const _FooterLinksAnchor = styled("a")(() => {
  return {
    textDecoration: "none",
    cursor: "pointer",
    ["&:hover"]: {
      [".link-text, > *"]: {
        textDecoration: "underline",
      },
    },
  };
});
